import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'are_recruitment_fees_and_related_costs_paid_by_wrkrs_in_line_w'

export const dataPointDefinition = {
  retracedId: 'are_recruitment_fees_and_related_costs_paid_by_wrkrs_in_line_w',
  name: 'Are recruitment fees and related costs paid by workers in line with legal requirements?',
  description:
    'Consult applicable legal requirements before answering this question. \r\r\n\r\r\nIf there are no applicable legal requirements, answer No applicable legal requirements. \r\r\n\r\r\nIf workers pay any recruitment fees or related costs, the intent of this question is to understand if the fees/costs are line with legal requirements (i.e. fee amounts or types of fees etc.).\r\r\n\r\r\nIf (i) workers have outstanding debts for recruitment fees and related costs, and (ii) the employer is using the debt to coerce workers or is manipulating the debt, and (iii) workers do not feel free to leave the job as a result of the debt, record this under the question, Can workers who owe debts to the facility and/or a third party freely leave their jobs?\r\r\n\r\r\nAnswer "Not Applicable" if workers do not pay any recruitment fees and related costs at any stage during recruitment and employment. If workers first had to pay for fees or costs before receiving reimbursement, consider whether this was in line with legal requirements.',
  meta: {},
  fieldTypeId: 'SELECT',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'ynna-nalr',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'ynna-nalr',
    },
    {
      name: 'Not Applicable',
      key: 'NOT_APPLICABLE',
      slcpIndex: 3,
      slcpOptionName: 'ynna-nalr',
    },
    {
      name: 'No applicable legal requirements',
      key: 'NO_APPLICABLE_LEGAL_REQS',
      slcpIndex: 4,
      slcpOptionName: 'ynna-nalr',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO', 'NOT_APPLICABLE', 'NO_APPLICABLE_LEGAL_REQS'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'fl-4--5',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 5030,
  sectionId: '2.2.4.1',
  impactArea: 'Recruitment, Hiring & Termination Practices',
  impactAreaId: 'RECRUITMENT_HIRING_AND_TERMINATION_PRACTICES',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
